import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getFormValues, getFormSyncErrors } from "redux-form";
import { withRouter } from "react-router-dom";
import cx from "classnames";
import Tab from "components/Tab";
import styles from "styles/modules/searchPage.module.scss";
import { withTranslation } from "react-i18next";
import { updateCurrentTabField } from "actions/tabs";
import { bindActionCreators } from "redux";
import { queriesContentUpdate } from "actions/content";
import { safeQuery } from "helpers";
import permissions, { checkPermissions } from "../../config/permissions";
import List from "./List";
import { openExportWizardModal } from "../../reducers/exportWizard";
import Loader from "../../pages/Ordering/common/Loader";
import { updateCurrentTabUrl } from "../../actions";
import { setCurrentTab } from "actions/index";

const FORM_NAME = (entity, hash) => `search-${entity}-${hash}-filters-main`;

const LIST_SHARED = {
    limit: 50,
    method: "post",
};

const LIST_INIT = {
    resource: {
        ...LIST_SHARED,
        key: "resource",
        code: "SPEC_RESOURCE",
        configUrlKey: "config_grid",
        configKey: "resource",
        configCode: "RESOURCE",
        type: "spec",
    },
    spec: {
        ...LIST_SHARED,
        key: "service",
        code: "SPEC_INSTANCE",
        configUrlKey: "config_grid",
        configKey: "service",
        configCode: "SERVICE",
        type: "spec",
    },
    document: {
        ...LIST_SHARED,
        key: "document",
        code: "SPEC_DOCUMENT",
        configUrlKey: "config_grid",
        configKey: "document",
        configCode: "DOCUMENT",
        type: "spec",
    },
    clevent: {
        ...LIST_SHARED,
        key: "calendar_events",
        code: "FTOP_SEARCH_CLEVENT",
        configUrlKey: "config_grid",
        configKey: "calendar_events",
        configCode: "FTOP_CLEVENT",
        type: "clevent",
    },
    task: {
        ...LIST_SHARED,
        key: "task",
        code: "ORDER_TASK",
        configUrlKey: "config_grid",
        configKey: "task",
        configCode: "TASK",
        type: "task",
    },
    customer: {
        ...LIST_SHARED,
        key: "customers",
        code: "CUSTOMER",
        configUrlKey: "config_grid",
        configKey: "customer",
        configCode: "CUSTOMER",
        type: "customer",
    },
    appeal: {
        ...LIST_SHARED,
        key: "appeal",
        code: "INTERACTION_REQUEST",
        configUrlKey: "config_grid",
        configKey: "appeal",
        configCode: "INTERACTION_REQUEST",
        type: "appeal",
    },
    contact_person: {
        ...LIST_SHARED,
        key: "contact_person",
        code: "CONTACT_PERSON",
        configUrlKey: "config_grid",
        configKey: "contact_person",
        configCode: "CONTACT_PERSON",
        type: "contact_person",
    },
};

function mapStateToProps(state, props) {
    const { hash, entity } = props.match.params;

    const attributesFilters = state.attributesFilters && state.attributesFilters[`search-${entity}`];

    let total = state.search.total;

    const entityGridMap = {
        task: "task",
        resource: "resource",
        document: "document",
        spec: "service",
        clevent: "calendar_events",
        customer: "customers",
        appeal: "appeal",
        contact_person: "contact_person",
    };

    if (entityGridMap[entity]) {
        total = _.get(state, `grid.${entityGridMap[entity]}_${hash}.result.total`, 0);
    }

    return {
        tabs: state.tabs,
        total,
        canSearchCustomer: checkPermissions(permissions.SearchOperations.search_customer),
        canSearchContactPersons: checkPermissions(permissions.SearchOperations.search_contactPersons),
        canSearchEvents: checkPermissions(permissions.CalendarOperations.view_calendar_event),
        canSearchServices: checkPermissions(permissions.SearchOperations.search_spec),
        canSearchResource: checkPermissions(permissions.SearchOperations.search_res),
        canSearchDocuments: checkPermissions(permissions.SearchOperations.search_document),
        canSearchTasks: checkPermissions(permissions.SearchOperations.search_order_task),
        canSearchAppeal: checkPermissions(permissions.SearchOperations.search_appeal),
        currentSearchQuery: state.search.query,

        allFilterFields: attributesFilters && attributesFilters.attributes,
        isExportAllowed: checkPermissions(permissions.SearchOperations.search_export),
        formValues: getFormValues(FORM_NAME(entity, hash))(state),
        formErrors: getFormSyncErrors(FORM_NAME(entity, hash))(state),
        query: state.search.searches[hash] || "",
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                updateCurrentTabField,
                queriesContentUpdate,
            },
            dispatch
        ),
        setCurrentTab: payload => dispatch(setCurrentTab(payload)),
        updateCurrentTabUrl: path => dispatch(updateCurrentTabUrl(path)),
        openExportWizardModal: () => dispatch(openExportWizardModal()),
    };
}

@withTranslation()
@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class TabContentNewGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopupOpen: false,
        };
        this.togglePopup = this.togglePopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.getPath = this.getPath.bind(this);
        this.renderTab = this.renderTab.bind(this);
    }

    componentDidMount() {
        const currentTab = this.props.tabs.current;
        const { hash, entity } = this.props.match.params;
        const urls = this.props.searchHeaderTabs.map(tab => this.getPath(tab));
        if (!currentTab || !urls.includes(currentTab.url)) {
            this.updateCurrentTab();
        }
        if (currentTab && currentTab.type === `search_${hash}` && !urls.includes(currentTab.url)) {
            this.props.updateCurrentTabUrl(this.getPath(entity));
        }
    }

    componentDidUpdate(prevProps) {
        const prevHash = prevProps.match.params.hash;
        const prevEntity = prevProps.match.params.entity;
        const { hash, entity } = this.props.match.params;
        if (prevHash !== hash) {
            this.updateCurrentTab();
        }
        if (prevHash === hash && prevEntity !== entity) {
            this.updateCurrentTab();
        }
    }

    updateCurrentTab() {
        const { hash, entity } = this.props.match.params;
        const url = this.getPath(entity);
        this.props.setCurrentTab({
            noRequest: true,
            isExact: true,
            params: this.props.match.params,
            path: this.props.match.path,
            url: url,
            name: () => (this.props.currentSearchQuery ? decodeURIComponent(this.props.currentSearchQuery) : "search"),
            queryKey: () => entity,
            storeName: () => entity,
            tabType: `search_${hash}`,
        });
    }

    togglePopup() {
        this.setState(prevState => ({ isPopupOpen: !prevState.isPopupOpen }));
    }

    closePopup() {
        if (this.state.isPopupOpen) this.setState({ isPopupOpen: false });
    }

    getPath(val) {
        const aPath = this.props.history.location.pathname.split("/");
        aPath[2] = val;
        return safeQuery(aPath.join("/"));
    }

    renderTab(tab, index) {
        const url = this.getPath(tab);
        const onClick = tab => {
            this.props.actions.updateCurrentTabField("queryKey", tab);
            this.props.actions.updateCurrentTabField("url", url);
        };
        return (
            <Tab
                val={tab}
                key={index}
                getPath={() => this.getPath(tab)}
                onClick={onClick}
                classPropName="search-grid-tab"
            />
        );
    }

    render() {
        const {
            total,
            match,
            t,
            canSearchContactPersons,
            canSearchCustomer,
            canSearchEvents,
            canSearchServices,
            canSearchResource,
            canSearchDocuments,
            canSearchTasks,
            canSearchAppeal,
            allFilterFields,
            formValues,
            formErrors,
            query,
            isExportAllowed,
            openExportWizardModal,
            searchHeaderTabs,
        } = this.props;
        const { hash, entity } = match.params;

        const filteredTabs = searchHeaderTabs.filter(key => {
            return {
                contact_person: canSearchContactPersons,
                customer: canSearchCustomer,
                clevent: canSearchEvents,
                spec: canSearchServices,
                resource: canSearchResource,
                document: canSearchDocuments,
                task: canSearchTasks,
                appeal: canSearchAppeal,
            }[key];
        });

        const currentTabAllowed = filteredTabs.some(key => key === entity);

        if (!currentTabAllowed) {
            const firstAvailableTab = filteredTabs[0];
            if (firstAvailableTab) {
                this.props.history.push(this.getPath(firstAvailableTab));
            }
        }

        const listInit = LIST_INIT[entity];

        return (
            <Fragment>
                <div className={styles.searchHeader}>
                    <div className={styles.resultsTitle}>
                        <span className={styles.title}>{t("searchFound")}</span>
                        <span className={styles.total}>{total}</span>
                    </div>
                    <div className={styles.tabsWrapper}>
                        <div id="card-bottom-row" className="column">
                            <div className="top-right">
                                {filteredTabs.map((tab, index) => this.renderTab(tab, index))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={cx("contentGridTab", "gridWrapper", "ordering-component-ui-core-wrapper")}>
                    {!allFilterFields && <Loader />}
                    {allFilterFields && currentTabAllowed && (
                        <List
                            listInit={listInit}
                            formValues={formValues}
                            formErrors={formErrors}
                            query={query}
                            entity={entity}
                            selectItemPath={entity}
                            allFilterFields={allFilterFields}
                            onGridExport={isExportAllowed && openExportWizardModal}
                            key={`${entity}-${hash}`}
                        />
                    )}
                </div>
            </Fragment>
        );
    }
}

export default TabContentNewGrid;
